import type { NavBarItem } from "components/NavBar";
import NavBar from "components/NavBar";
import { type FC, useMemo } from "react";
import { Outlet } from "react-router-dom";

import { WHITELIST_CATEGORIES } from "./categories";

const WhitelistRootRoute: FC = () => {
  const nav = useMemo<NavBarItem[]>(
    () =>
      WHITELIST_CATEGORIES.map(c => ({
        title: c.title,
        path: c.id,
      })),
    [],
  );

  return (
    <div className="flex-1 flex flex-col gap-y-2 mt-4">
      <div className="rounded-xl bg-background p-4">
        <NavBar items={nav} pattern="/whitelist" />
      </div>
      <div className="flex-1 flex flex-col rounded-xl bg-background gap-y-2 p-4">
        <Outlet />
      </div>
    </div>
  );
};

export default WhitelistRootRoute;
